import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
import { failureHash } from "./plansubscription.static";
export class ApiEpBillingPlansubscription {
}
ApiEpBillingPlansubscription.list = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/plansubscription/`,
    method: "GET",
    query: req === null || req === void 0 ? void 0 : req.query,
}, failureHash);
ApiEpBillingPlansubscription.convert = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/plansubscription/convert/${req.path.plan_id}`,
    method: "POST",
}, failureHash);
ApiEpBillingPlansubscription.exchangeRate = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/plansubscription/exchange-rate`,
    method: "GET",
    query: req.query,
}, failureHash);
ApiEpBillingPlansubscription.retrieve = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/plansubscription/${req.path.id}`,
    method: "GET",
}, failureHash);
//# sourceMappingURL=plansubscription.js.map